import axios from 'axios'

export default {
    getAll: () => axios.get(`/text_block`),
    add: formData => axios.post(`/text_block/create`, formData),
    edit: formData => axios.put(`/text_block/edit`, formData),
    delete: id => axios.delete(`/text_block/${id}`)
}
